<app-inventory-template
  class="tf2hunt--skins-shadow"
  [inventoryOptions]="{
items_load_endpoint: 'upgrader_items',
items_search_enabled: true,
items_sort_enabled: true,
items_pure_filter_enabled: false,
typography_action_button: 'Withdraw items',
typography_title: 'Select Skin',
typography_title_icon: 'assets/icons/games/upgrade.svg',
}"
  [theme]="'default'"
  [(selectedSkins)]="upgraderService.selectedSkinsS"
  [inventoryFooterUISettings]="{
    disabled: true,
  }"
  [balanceType]="sessionService.balanceType()"
  [inventorySkinsListConfig]="{
    mobile: {
      padding: '8px',
    },
  }"
  [isProcessing]="upgraderService.isProcessing()"
>
</app-inventory-template>
